var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpediaGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#0d0596;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,.2H150v150H0Z",
    transform: "translate(0 -0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.92,69.83c0-12.34-11.43-30.08-33.09-30.08C55,39.75,41.75,56.89,41.75,74.34c0,20.75,14.43,35.79,39.1,35.79h46.92A62.23,62.23,0,0,1,75.13,138.4,63.47,63.47,0,0,1,11.67,74.94c0-34.89,28.27-63.77,63.46-63.77A64,64,0,0,1,138.9,74.94a72.21,72.21,0,0,1-3,19.85H64.6V87.87l25-.9c12.63-.6,18.35-6.92,18.35-17.14",
    transform: "translate(0 -0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpediaGroup);
export default __webpack_public_path__ + "static/media/expedia-group.712f8fe4ef91f45c21680fd507d8d10e.svg";
export { ForwardRef as ReactComponent };